import { render } from "./MenuCycle-edit.vue?vue&type=template&id=6553bc82"
import script from "./MenuCycle-edit.vue?vue&type=script&lang=js"
export * from "./MenuCycle-edit.vue?vue&type=script&lang=js"

import "./MenuCycle-edit.vue?vue&type=style&index=0&id=6553bc82&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__